import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { Toaster, toast } from 'sonner';
import { router } from '@/app/router';
import { ConfirmProvider } from '@/components/ui/confirm';
import { TooltipProvider } from '@/components/ui/menu';
import { AUTH_KEY, setAuthState } from '@/hooks/auth';
import { onUnauthorized } from '@/lib/api';
import { queryClient } from '@/lib/query';
import { useTheme } from '@/lib/theme';
import './styles/index.css';

onUnauthorized(() => {
  if (queryClient.getQueryData(AUTH_KEY)) {
    setAuthState(null);
    queryClient.removeQueries({ queryKey: ['b'] });
    toast.error('Your session has ended. Please sign in again.');
  }
});

function ThemedToaster() {
  const dark = useTheme((s) => s.dark);
  return (
    <Toaster
      theme={dark ? 'dark' : 'light'}
      position="top-right"
      richColors
      closeButton
      toastOptions={{ className: 'font-sans' }}
    />
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <ConfirmProvider>
          <RouterProvider router={router} />
          <ThemedToaster />
        </ConfirmProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
